import Autoplay from "https://cdn.jsdelivr.net/npm/embla-carousel-autoplay@8.0.0-rc22/+esm";
import ClassNames from "https://cdn.jsdelivr.net/npm/embla-carousel-class-names@8.0.0-rc22/+esm";
import EmblaCarousel from "https://cdn.jsdelivr.net/npm/embla-carousel@8.0.0-rc22/+esm";
import { addPrevNextBtnsClickHandlers } from "./EmblaCarouselArrowButtons.js";
import { addContentToDots } from "./EmblaCarouselContent.js";
import { addDotBtnsAndClickHandlers } from "./EmblaCarouselDotButton.js";
import { setupTweenParallax } from "./EmblaCarouselTweenParallax.js";
const OPTIONS = { dragFree: false, loop: true, startIndex: 1 };
const plugins = [Autoplay(), ClassNames()];

const emblaNode = document.querySelector(".embla");
const viewportNode = emblaNode.querySelector(".embla__viewport");
const prevBtn = emblaNode.querySelector(".embla__button--prev");
const nextBtn = emblaNode.querySelector(".embla__button--next");
const dotsNode = document.querySelector(".embla__dots");
const contentNode = document.querySelector(".embla__content");
const slides = emblaNode.querySelectorAll(".embla__slide");

const emblaApi = EmblaCarousel(viewportNode, OPTIONS, plugins);
const removeTweenParallax = setupTweenParallax(emblaApi);

const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
  emblaApi,
  prevBtn,
  nextBtn
);
const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(
  emblaApi,
  dotsNode
);
const removeContent = addContentToDots(emblaApi, contentNode);
// const removeZoomSlide = setupZoomSlide(emblaApi, slides);
emblaApi
  .on("destroy", removeTweenParallax)
  .on("destroy", removePrevNextBtnsClickHandlers)
  .on("destroy", removeContent)
  .on("destroy", removeDotBtnsAndClickHandlers);
// .on("destroy", removeZoomSlide);
